import { rootStore } from '../mobx/rootStore';
import LocalDbService, { TASKS_TABLE_NAME_MOBX, UPDATE_ON_ID } from './localDbService';
import { RawTask } from '../mobx/interfaces/task';

interface MobxTasksCacheServiceProps {
  organizationId: string;
}

let singleton: MobxTasksCacheService | null = null;
let organizationId: string | null = null;

export default class MobxTasksCacheService extends LocalDbService {
  constructor(props: MobxTasksCacheServiceProps) {
    const db_name = `${props.organizationId}`;
    const serviceProps = { ...props, dbName: db_name, tableName: TASKS_TABLE_NAME_MOBX };
    organizationId = props.organizationId;
    super(serviceProps);
  }

  static getInstance() {
    const workspaceId = rootStore.workspaceStore.currentWorkspace?.id || 'Unknown';
    if (!singleton || organizationId !== workspaceId) {
      singleton = new MobxTasksCacheService({ organizationId: workspaceId });
    }
    return singleton;
  }

  static removeInstance() {
    if (singleton) singleton.closeDb();
    organizationId = null;
    singleton = null;
  }

  async getTasks() {
    const tasks = await this.getDb().toArray();
    return tasks as RawTask[];
  }

  async setTasks(tasks: RawTask[]) {
    return await this.getDb().bulkPut(tasks);
  }

  async updateTask(taskId: string, changes: Partial<RawTask>) {
    return await this.getDb().update(taskId, changes);
  }

  async getTasksByIds(taskIds: string[]) {
    const tasks = (await this.getDb().bulkGet(taskIds)).filter((task: RawTask | undefined): task is RawTask => !!task);
    return tasks;
  }

  async removeBulk(taskIds: string[]) {
    await this.getDb().bulkDelete(taskIds);
  }

  async getLastUpdatedTime() {
    try {
      const result = await super.getLastUpdatedTime(`${UPDATE_ON_ID.TASKS}_${organizationId}`);
      if (result === 0 || new Date(result).toString() === 'Invalid Date') {
        return null;
      }
      return new Date(result);
    } catch (err) {
      return null;
    }
  }

  async updateLastUpdatedTime(date = new Date()) {
    const result = await super.setLastUpdatedTime(`${UPDATE_ON_ID.TASKS}_${organizationId}`, date.toUTCString());
    return result;
  }
}
